import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { SURVEY_QUERIES } from "~/shared/api/surveys/surveys.queries";
import { notFound } from "~/shared/util/notFound";

export function editSurveyViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { surveyId } = params;

  if (!surveyId) {
    return notFound();
  }

  queryClient.prefetchQuery(SURVEY_QUERIES.detail(surveyId));

  return null;
}
